import { defaultHttpClient } from '../../httpClient';
import type { GetRankingFiltersResponse } from './types';

export const getRankingFilters = () => {
  return defaultHttpClient
    .request<GetRankingFiltersResponse>({
      method: 'GET',
      url: '/api/v2/goods/ranking-filters/',
    })
    .then(result => result.data);
};